import React from 'react';

class Loader extends React.Component {
    render() {
        return (
            <div ddsi-id="react-loader" className="loading-content">
                <div className="progress-indicator" />
            </div >
        );
    }
}

export default Loader;